<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-driver"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new driver</small
                >
              </legend>
              <form @submit.prevent="newDriver()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>driver name</label>
                      <input
                        type="text"
                        class="form-control drivers_name"
                        placeholder="drivers name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ID/Passport no</label>
                      <input
                        type="text"
                        class="form-control id_passport_no"
                        placeholder="destination name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number kenya</label>
                      <input
                        type="text"
                        class="form-control phone_number_ke"
                        placeholder="phone number kenya"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number Sudan</label>
                      <input
                        type="text"
                        class="form-control phone_number_su"
                        placeholder="phone number sudan"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingDriver"
                >
                  <i class="fa fa-plus"></i> Add driver
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingDriverLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="update-driver"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Updates driver</small
                >
              </legend>
              <form @submit.prevent="driverUpdate()">
                <div class="row">
                  <input type="hidden" class="id" :value="Driver.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>driver name</label>
                      <input
                        type="text"
                        class="form-control Udrivers_name"
                        placeholder="drivers name"
                        :value="Driver.drivers_name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ID/Passport no</label>
                      <input
                        type="text"
                        class="form-control Uid_passport_no"
                        placeholder="destination name"
                        :value="Driver.id_passport_no"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number kenya</label>
                      <input
                        type="text"
                        class="form-control Uphone_number_ke"
                        placeholder="phone number kenya"
                        :value="Driver.phone_number_ke"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number Sudan</label>
                      <input
                        type="text"
                        class="form-control Uphone_number_su"
                        placeholder="phone number sudan"
                        :value="Driver.phone_number_su"
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat updatingDriver"
                >
                  <i class="fa fa-plus"></i> Update driver
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat updatingDriverLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage drivers</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-driver"
              >
                <i class="fa fa-plus"></i> new driver
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="driversLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >Loading drivers...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemDrivers"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Action'">
                      <button
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewDriver(props.row.id)"
                      >
                        <i class="fa fa-edit"></i> Edit Driver
                      </button>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Driver name",
          field: "drivers_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Id/Passport no",
          field: "id_passport_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Phone number kenya",
          field: "phone_number_ke",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Phone number sudan",
          field: "phone_number_su",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadDrivers();
  },
  computed: {
    ...mapGetters(["systemDrivers", "Driver"]),
  },
  methods: {
    ...mapActions(["loadDrivers", "newDriver", "viewDriver", "driverUpdate"]),
  },
};
</script>
<style scoped>
.creatingDriverLoader {
  display: none;
}
.updatingDriverLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/drivers/managedrivers.vue